import type { RundownCueOrderItem } from '@rundown-studio/types'
import { useDraggable } from '@dnd-kit/core'
import { CSS } from '@dnd-kit/utilities'

export const useDraggableCue = (cue: RundownCueOrderItem) => {
  const draggable = useDraggable({
    id: cue.id,
    data: {
      cue,
    },
  })

  const style = {
    transform: CSS.Transform.toString(draggable.transform),
  }

  return {
    draggable,
    style,
  }
}
